module.exports = __webpack_public_path__ + "static/visual-709cc48dad6763d58baaf5b6347e6b48.png";